import { render, staticRenderFns } from "./SubmitionFooter.vue?vue&type=template&id=6c88d298&"
import script from "./SubmitionFooter.vue?vue&type=script&lang=js&"
export * from "./SubmitionFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports